import { render, staticRenderFns } from "./onlineConsult.vue?vue&type=template&id=98d90de0&scoped=true"
import script from "./onlineConsult.vue?vue&type=script&lang=js"
export * from "./onlineConsult.vue?vue&type=script&lang=js"
import style0 from "./onlineConsult.vue?vue&type=style&index=0&id=98d90de0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d90de0",
  null
  
)

export default component.exports